// extracted by mini-css-extract-plugin
export default {"postsBlock":"MyPosts_postsBlock__bCUwM","posts":"MyPosts_posts__29Sa-"};